// src/pages/FacturacionPresupuestos/CatalogoConceptosTab.js
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { 
    FaTag, 
    FaPlus, 
    FaSearch, 
    FaEdit, 
    FaTrash, 
    FaTimes, 
    FaDollarSign,
    FaBolt
} from 'react-icons/fa';
import './GestionTabs.css';

const UNIDADES_MEDIDA = [
    'Servicio',
    'Pieza',
    'Metro lineal (m)',
    'Metro cuadrado (m²)',
    'Metro cúbico (m³)',
    'Lote',
    'Hora',
    'Día',
    'Mes',
    'Paquete',
    'Kilogramo (kg)',
    'Litro (L)'
];

const CATEGORIAS_TECNOLOGICAS_INICIALES = [
    'Mantenimiento',
    'Electricidad',
    'Software',
    'Hardware',
    'Rastreo (GPS / Telemetría)',
    'Video-vigilancia (CCTV)',
    'Seguridad',
    'Capacitación',
    'Automatización y Control de Accesos (IoT)',
    'Telecomunicaciones y Redes',
    'Servicios en la Nube e Infraestructura Digital',
    'Consultoría y Desarrollo Tecnológico',
    'Soporte Técnico y Helpdesk',
    'Ciberseguridad y Protección de Datos',
    'Integración de Sistemas Automatizados'
];

const CatalogoConceptosTab = ({
    conceptos = [],
    onGuardarConcepto,
    onEliminarConcepto,
    onSembrarCatalogo
}) => {
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [conceptoEditando, setConceptoEditando] = useState(null);

    // Stock de Categorías Tecnológicas (Punto 4)
    const [categoriasStock, setCategoriasStock] = useState(() => {
        try {
            const saved = localStorage.getItem('facturacion_stock_categorias_v1');
            if (saved) return JSON.parse(saved);
        } catch (e) {}
        return CATEGORIAS_TECNOLOGICAS_INICIALES;
    });

    const [mostrarNuevaCategoria, setMostrarNuevaCategoria] = useState(false);
    const [nuevaCategoriaTexto, setNuevaCategoriaTexto] = useState('');

    const guardarStockCategorias = (nuevas) => {
        setCategoriasStock(nuevas);
        try {
            localStorage.setItem('facturacion_stock_categorias_v1', JSON.stringify(nuevas));
        } catch (e) {}
    };

    const handleConfirmarNuevaCategoria = () => {
        const cat = nuevaCategoriaTexto.trim();
        if (!cat) return;
        if (!categoriasStock.includes(cat)) {
            const actualizadas = [...categoriasStock, cat];
            guardarStockCategorias(actualizadas);
            setFormConcepto(prev => ({ ...prev, categoria: cat }));
        }
        setNuevaCategoriaTexto('');
        setMostrarNuevaCategoria(false);
    };

    const handleEliminarCategoriaSeleccionada = async () => {
        if (categoriasStock.length <= 1) {
            Swal.fire({
                title: 'Categoría Requerida',
                text: 'Debes conservar al menos una categoría en el stock.',
                icon: 'warning',
                confirmButtonColor: '#0d9488'
            });
            return;
        }
        const actual = formConcepto.categoria;
        const res = await Swal.fire({
            title: '¿Eliminar Categoría?',
            html: `¿Deseas eliminar la categoría <strong>"${actual}"</strong> del stock?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#94a3b8',
            confirmButtonText: 'Sí, eliminar categoría',
            cancelButtonText: 'Cancelar'
        });
        if (!res.isConfirmed) return;
        const actualizadas = categoriasStock.filter(c => c !== actual);
        guardarStockCategorias(actualizadas);
        setFormConcepto(prev => ({ ...prev, categoria: actualizadas[0] || 'Mantenimiento' }));
        Swal.fire({
            title: 'Categoría eliminada',
            text: `La categoría "${actual}" ha sido removida del stock.`,
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
        });
    };

    const [formConcepto, setFormConcepto] = useState({
        nombre: '',
        descripcion: '',
        unidad: 'Servicio',
        precioUnitario: '',
        categoria: 'Mantenimiento'
    });

    const abrirModal = (conc = null) => {
        if (conc) {
            setConceptoEditando(conc);
            setFormConcepto({
                nombre: conc.nombre || conc.descripcion || '',
                descripcion: conc.descripcion || '',
                unidad: conc.unidad || 'Servicio',
                precioUnitario: conc.precioUnitario || '',
                categoria: conc.categoria || 'Mantenimiento'
            });
        } else {
            setConceptoEditando(null);
            setFormConcepto({
                nombre: '',
                descripcion: '',
                unidad: 'Servicio',
                precioUnitario: '',
                categoria: 'Mantenimiento'
            });
        }
        setModalAbierto(true);
    };

    const handleGuardar = (e) => {
        e.preventDefault();
        if (!formConcepto.nombre.trim()) {
            alert('Por favor especifica el nombre o descripción del concepto.');
            return;
        }

        const data = {
            ...formConcepto,
            id: conceptoEditando?.id || Date.now().toString(),
            precioUnitario: Number(formConcepto.precioUnitario) || 0,
            actualizadoEn: new Date().toISOString()
        };

        onGuardarConcepto(data);
        setModalAbierto(false);
    };

    const conceptosFiltrados = conceptos.filter(c => {
        const texto = `${c.nombre || ''} ${c.descripcion || ''} ${c.categoria || ''}`.toLowerCase();
        return !busqueda || texto.includes(busqueda.toLowerCase());
    });

    return (
        <div className="gestion-tab-container">
            {/* Header */}
            <div className="gestion-tab-header">
                <div className="gestion-tab-title-group">
                    <h2>
                        <FaTag style={{ color: '#0d9488' }} /> Catálogo de Conceptos y Costos
                    </h2>
                    <p>
                        Catálogo de partidas con aprendizaje y actualización de precios unitarios sugeridos.
                    </p>
                </div>
                <div className="gestion-tab-actions">
                    <button 
                        type="button" 
                        className="btn-primary-zen"
                        style={{ background: '#0d9488' }}
                        onClick={() => abrirModal()}
                    >
                        <FaPlus /> Nuevo Concepto
                    </button>
                </div>
            </div>

            {/* Barra de Filtros */}
            <div className="gestion-filter-bar">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                    <FaSearch style={{ color: '#94a3b8' }} />
                    <input 
                        type="text"
                        className="gestion-search-input"
                        placeholder="Buscar concepto por nombre, descripción o categoría..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>
            </div>

            {/* Tabla */}
            <div className="gestion-table-wrapper">
                <table className="gestion-zen-table">
                    <thead>
                        <tr>
                            <th>Concepto / Partida</th>
                            <th>Descripción Detallada</th>
                            <th>Categoría</th>
                            <th>Unidad de Medida</th>
                            <th>Precio Unitario Sugerido</th>
                            <th>Última Actualización</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conceptosFiltrados.length === 0 ? (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '32px', color: '#94a3b8' }}>
                                    No hay conceptos registrados. Al emitir una remisión o presupuesto se irán guardando automáticamente aquí.
                                </td>
                            </tr>
                        ) : (
                            conceptosFiltrados.map((c) => (
                                <tr key={c.id}>
                                    <td style={{ fontWeight: 700, color: '#0f172a' }}>
                                        {c.nombre || c.descripcion}
                                    </td>
                                    <td style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {c.descripcion || '-'}
                                    </td>
                                    <td>
                                        <span style={{ background: '#f1f5f9', padding: '3px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>
                                            {c.categoria || 'General'}
                                        </span>
                                    </td>
                                    <td>{c.unidad || 'Servicio'}</td>
                                    <td style={{ fontWeight: 700, color: '#2b5329' }}>
                                        ${(Number(c.precioUnitario) || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                    </td>
                                    <td style={{ fontSize: '11px', color: '#64748b' }}>
                                        {c.actualizadoEn ? new Date(c.actualizadoEn).toLocaleDateString('es-MX') : 'Reciente'}
                                    </td>
                                    <td>
                                        <div className="row-actions-group">
                                            <button 
                                                type="button" 
                                                className="btn-row-action"
                                                onClick={() => abrirModal(c)}
                                                title="Editar Concepto"
                                            >
                                                <FaEdit /> Editar
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn-row-action delete"
                                                onClick={() => onEliminarConcepto(c.id)}
                                                title="Eliminar Concepto"
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal para Agregar/Editar Concepto */}
            {modalAbierto && (
                <div className="modal-sendgrid-overlay" onClick={() => setModalAbierto(false)}>
                    <div className="modal-sendgrid-container" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-sendgrid-header modal-header-conceptos">
                            <h3 className="modal-sendgrid-title modal-title-conceptos">
                                <FaTag style={{ color: '#0d9488' }} /> {conceptoEditando ? 'Editar Concepto' : 'Nuevo Concepto'}
                            </h3>
                            <button type="button" className="modal-sendgrid-close" onClick={() => setModalAbierto(false)}>
                                <FaTimes />
                            </button>
                        </div>
                        <form onSubmit={handleGuardar}>
                            <div className="modal-sendgrid-body">
                                <div className="mini-form-grid">
                                    <div className="mini-form-full sendgrid-input-group">
                                        <label>Nombre del Concepto *</label>
                                        <input 
                                            type="text" 
                                            required
                                            className="sendgrid-input-control"
                                            value={formConcepto.nombre}
                                            onChange={(e) => setFormConcepto({ ...formConcepto, nombre: e.target.value })}
                                            placeholder="Ej. Mantenimiento Preventivo de Bomba de Agua"
                                        />
                                    </div>
                                    <div className="mini-form-full sendgrid-input-group">
                                        <label>Descripción / Alcance Sugerido</label>
                                        <textarea 
                                            rows={3}
                                            className="sendgrid-input-control"
                                            value={formConcepto.descripcion}
                                            onChange={(e) => setFormConcepto({ ...formConcepto, descripcion: e.target.value })}
                                            placeholder="Detalles técnicos, mano de obra, refacciones incluidas..."
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>Unidad de Medida</label>
                                        <select 
                                            className="sendgrid-input-control"
                                            value={formConcepto.unidad}
                                            onChange={(e) => setFormConcepto({ ...formConcepto, unidad: e.target.value })}
                                        >
                                            {UNIDADES_MEDIDA.map(u => (
                                                <option key={u} value={u}>{u}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>Precio Unitario Sugerido (MXN) *</label>
                                        <input 
                                            type="number" 
                                            step="0.01"
                                            required
                                            className="sendgrid-input-control"
                                            value={formConcepto.precioUnitario}
                                            onChange={(e) => setFormConcepto({ ...formConcepto, precioUnitario: e.target.value })}
                                            placeholder="0.00"
                                        />
                                    </div>
                                    <div className="mini-form-full sendgrid-input-group">
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                            <label style={{ margin: 0 }}>Categoría / Rubro Tecnológico</label>
                                            <div style={{ display: 'flex', gap: '6px' }}>
                                                <button
                                                    type="button"
                                                    onClick={() => setMostrarNuevaCategoria(!mostrarNuevaCategoria)}
                                                    style={{
                                                        background: '#0d9488',
                                                        color: '#ffffff',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        padding: '3px 8px',
                                                        fontSize: '11px',
                                                        fontWeight: 600,
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px'
                                                    }}
                                                    title="Agregar una nueva categoría al stock"
                                                >
                                                    <FaPlus /> Nueva Categoría
                                                </button>
                                                {formConcepto.categoria && (
                                                    <button
                                                        type="button"
                                                        onClick={handleEliminarCategoriaSeleccionada}
                                                        style={{
                                                            background: '#fef2f2',
                                                            color: '#ef4444',
                                                            border: '1px solid #fecaca',
                                                            borderRadius: '4px',
                                                            padding: '3px 8px',
                                                            fontSize: '11px',
                                                            fontWeight: 600,
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '4px'
                                                        }}
                                                        title="Eliminar la categoría seleccionada del stock"
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {/* Input inline si el usuario presiona "Nueva Categoría" */}
                                        {mostrarNuevaCategoria && (
                                            <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', background: '#f0fdfa', padding: '8px', borderRadius: '6px', border: '1px solid #99f6e4' }}>
                                                <input
                                                    type="text"
                                                    className="sendgrid-input-control"
                                                    placeholder="Escribe el nombre de la nueva categoría..."
                                                    value={nuevaCategoriaTexto}
                                                    onChange={(e) => setNuevaCategoriaTexto(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            handleConfirmarNuevaCategoria();
                                                        }
                                                    }}
                                                    style={{ flex: 1, height: '34px', fontSize: '13px' }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={handleConfirmarNuevaCategoria}
                                                    style={{ background: '#0d9488', color: '#ffffff', border: 'none', borderRadius: '6px', padding: '0 12px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}
                                                >
                                                    Agregar
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setMostrarNuevaCategoria(false)}
                                                    style={{ background: '#e2e8f0', color: '#475569', border: 'none', borderRadius: '6px', padding: '0 8px', fontSize: '12px', cursor: 'pointer' }}
                                                >
                                                    <FaTimes />
                                                </button>
                                            </div>
                                        )}

                                        <select 
                                            className="sendgrid-input-control"
                                            value={formConcepto.categoria}
                                            onChange={(e) => setFormConcepto({ ...formConcepto, categoria: e.target.value })}
                                            style={{ fontWeight: 600, color: '#0f172a' }}
                                        >
                                            {categoriasStock.map(cat => (
                                                <option key={cat} value={cat}>📁 {cat}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-sendgrid-footer">
                                <button type="button" className="btn-modal-cancel" onClick={() => setModalAbierto(false)}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn-modal-send btn-save-conceptos">
                                    Guardar Concepto
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CatalogoConceptosTab;
